import React, { useEffect, useState } from 'react';
import LoginForm from '@components/auth/LoginForm';
import AuthLayout from '@layouts/AuthLayout';
import login from '@illustrations/auth/login.json';
import GeniebookLogo from '@assets/illustration/auth/geniebook-logo';
import './LoginPage.css';
import { IUserData } from '@models/interfaces/user.interface';
import UserTypeCard from '@components/auth/UserTypeCard';
import { Link } from 'geniebook-ui/dist';
import { Helmet } from 'react-helmet-async';
import { BASE_URL } from '@utils/constants/url.constants';
import {
  ContainerForm,
  ContainerSelector,
  PhoneIllustrationDiv,
  TabletIllustrationDiv,
} from './styles/Auth.style';

const LoginPage = () => {
  const [dataUserType, setDataUserType] = useState<IUserData[]>([]);
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [userCard, setUserCard] = useState<boolean>(false);

  useEffect(() => {
    const data = localStorage.getItem('multipleAccountsLogin');
    const options = JSON.parse(
      localStorage.getItem('rememberMeLogin') ?? 'false',
    );
    if (data) {
      setDataUserType(JSON.parse(data));
      setRememberMe(options.remember_me);
      setUserCard(true);
    }
  }, []);
  const handleAccountLogin = (
    data: IUserData[],
    options: { remember_me: boolean },
  ) => {
    localStorage.setItem('multipleAccountsLogin', JSON.stringify(data));
    localStorage.setItem(
      'rememberMeLogin',
      JSON.stringify(options.remember_me),
    );
    setRememberMe(options.remember_me);
    setDataUserType(data);
    setUserCard(true);
  };

  return (
    <>
      <Helmet>
        <title>Geniebook - Login</title>
        <meta name="description" content="Login" />
      </Helmet>
      <AuthLayout illustration={login}>
        {userCard ? (
          <>
            <ContainerSelector>
              <div className="font-black text-primary-navyblue text-[32px] leading-[54px] mb-[32px]">
                Select Account
              </div>
              <UserTypeCard users={dataUserType} remember_me={rememberMe} />
            </ContainerSelector>
          </>
        ) : (
          <>
            <div className="w-full">
              <TabletIllustrationDiv />
              <PhoneIllustrationDiv />
              <ContainerForm>
                <div className="text-left px-[38px] max-sm:px-[24px] lg:min-w-[343px]">
                  <div className="mb-[32px] lg:hidden">
                    <GeniebookLogo className="w-[155px] h-[24px]" />
                  </div>
                  <div className="font-black text-primary-navyblue text-[32px] leading-[32px] mb-[20px]">
                    Login
                  </div>
                  <div className="mb-[33px] text-[14px] leading-[14px] link-text">
                    New to Geniebook?{' '}
                    <a
                      href={`${BASE_URL}create_account`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Link className="!font-bold cursor-pointer">Sign up</Link>
                    </a>
                  </div>
                </div>
                <LoginForm selectAccountState={handleAccountLogin} />
              </ContainerForm>
              <div className="w-full h-[20px]"></div>
            </div>
          </>
        )}
      </AuthLayout>
    </>
  );
};

export default LoginPage;
